import { createContext, useContext } from 'react';
import type { Dispatch, SetStateAction } from 'react';

type ComplaintProps = {
  generated: boolean;
  setGenerated: Dispatch<SetStateAction<boolean>>;
};

export const Context = createContext<ComplaintProps>({} as ComplaintProps);

export const useComplaintContext = () => {
  return useContext(Context);
};
